import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Button, Card } from '@tecsinapse/cortex-react'
import React from 'react'
import { PiChatSlash } from 'react-icons/pi'
import { Link } from 'react-router-dom'

import { ItemBibliotecaHomeCard } from './item-biblioteca-home-card'
import { LoadingCards } from '@/core/components/loading-cards'
import { EmptyList } from '@/core/components/empty-list'
import { ItemBiblioteca } from '@/core/types/graphql'
import { useLastCreatedBox } from './use-last-created-box'

interface BibliotecaVirtualLastCreatedBoxCortexProps {
  pathRoute: string
}

export const BibliotecaVirtualLastCreatedBox = ({
  pathRoute
}: BibliotecaVirtualLastCreatedBoxCortexProps) => {
  const { ultimosModificados, loading } = useLastCreatedBox()
  if (loading) return <LoadingCards />

  if ((ultimosModificados ?? []).length === 0)
    return (
      <EmptyList
        title={t`Nada por aqui`}
        Icon={<PiChatSlash size={48} />}
        subTitle={t`Você ainda não possui arquivos.`}
      />
    )

  return (
    <Card className={'flex flex-1 flex-col min-w-0'}>
      <div className={'flex justify-between items-center mb-kilo'}>
        <p className={'text-h3 font-bold'}>{t`Biblioteca Virtual`}</p>
        <Link to={pathRoute} className={'no-underline'}>
          <Button>
            <Trans>Acessar biblioteca virtual</Trans>
          </Button>
        </Link>
      </div>
      {ultimosModificados?.map((item: ItemBiblioteca, index: number) => (
        <ItemBibliotecaHomeCard
          itemBiblioteca={item}
          key={`${item.nome}-${index}`}
        />
      ))}
    </Card>
  )
}
